import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Israeli ID Number validator following Single Responsibility Principle
 */
export class IlValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Israeli ID Number',
      pattern: /^\d{9}$/,
      length: 9
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Israeli ID must be exactly 9 digits'
    );
  }

  validateChecksum(id) {
    // Israeli ID uses Luhn algorithm with modifications
    let sum = 0;
    
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(id[i]);
      
      // Multiply every second digit by 2
      if (i % 2 === 1) {
        digit *= 2;
        // If result is two digits, add them together
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    if (sum % 10 !== 0) {
      return ValidationResult.invalid('Invalid Israeli ID checksum');
    }

    return ValidationResult.valid('Valid Israeli ID');
  }
}